import {ObjectDTO} from "./object-dto";

export class EquipeDTO extends ObjectDTO{

  id: number;
  libelle: string;
  actif:boolean;
  code:string;

}
